import { Avatar, Box, ButtonText, Typography } from '@percent/lemonade'
import styled from 'styled-components'
import { AttendeesListProps } from './attendees-list.types'

const StyledListItem = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: ${theme.sizes[3]} 0;
    border-bottom: 1px solid ${theme.colors.gray90};
  `}
`

const StyledAttendeeInfoWrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
`

const StyledAttendeeDetails = styled.div<{ $hideAvatars?: boolean }>`
  ${({ theme, $hideAvatars }) => `
    display: flex;
    flex-flow: column;
    ${$hideAvatars ? '' : `margin-left: ${theme.sizes[2]};`}
  `}
`

export const AttendeesList = ({
  data,
  displayEmailAddresses,
  hideAvatars,
  actionButton,
}: AttendeesListProps) => (
  <div>
    {data?.pages
      ?.flatMap((page) => (Array.isArray(page) ? page : []))
      ?.map((attendee) => (
        <StyledListItem key={attendee.id}>
          <StyledAttendeeInfoWrapper>
            {!hideAvatars && (
              <Avatar
                key={attendee.id}
                image={attendee.image}
                size="medium"
                alt={attendee.preferredName || attendee.fullName}
                shape="oval"
                border
              />
            )}
            <StyledAttendeeDetails $hideAvatars={hideAvatars}>
              <Typography>{attendee.preferredName || attendee.fullName}</Typography>
              {displayEmailAddresses && attendee.email ? (
                <Typography $color="gray600">{attendee.email}</Typography>
              ) : null}
            </StyledAttendeeDetails>
          </StyledAttendeeInfoWrapper>
          {actionButton ? (
            <Box>
              <ButtonText onClick={() => actionButton.onClick(attendee)}>
                {actionButton.label}
              </ButtonText>
            </Box>
          ) : null}
        </StyledListItem>
      ))}
  </div>
)
